import { useHeaderProps } from '../../../hooks/useHeaderProps'
import { Props } from './Layout'

export const useProps = (): Props => {
  const headerProps = useHeaderProps()
  return { ...headerProps }
}
